<template>
  <v-breadcrumbs
    :items="filteredBreadcrumbs"
    class="crumbs sav-breadcrumbs mt-0 ml-0 pt-0 pb-3 px-0"
  />
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SavBreadcrumbs',
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['savitarnaBreadcrumbs']),
    filteredBreadcrumbs() {
      return this.savitarnaBreadcrumbs.concat(
        this.breadcrumbs.filter((item) => {
          if (this.dontShowBreadcrumb(item)) {
            return item ?? ''
          }
        })
      )
    },
    breadcrumbs() {
      const { matched } = this.$route
      return matched.map((route, index) => {
        let to =
          index === matched.length - 1
            ? this.$route.path
            : route.path || route.redirect
        let text = this.$vuetify.lang.t('' + route.meta.title)
        to = this.checkVariables(to)
        text = this.checkVariables(text)
        return {
          text: this.$t(text),
          to: to,
          exact: false,
          disabled: false,
        }
      })
    },
  },
  methods: {
    dontShowBreadcrumb(item) {
      // return item.text !== 'undefined' && item.text !== 'Pradžia' && item.text !== 'Pagrindinis'
      let savArray = [
        'undefined',
        'Pradžia',
        'Pagrindinis',
        'Naujas įgaliojimas',
        'Mano įgaliojimai',
        'Mano dokumentai',
        'Išrašų užsakymas',
        'Pranešimai',
      ]
      return !savArray.includes(item.text)
    },
    checkVariables(text) {
      if (typeof text !== 'string') {
        return text
      }
      // text = text.replace(':objektasID', this.objektasID)
      return text === 'null' ? '' : text
    },
  },
  created() {},
}
</script>

<style lang="scss">
.crumbs {
  font-family: 'Open Sans';
  font-weight: normal;
  li {
    font-size: 12px !important;
  }
}
</style>
